import { TOWER_DEFS } from "../constants/towers";

const glow = (ctx, color, blur, draw) => {
	ctx.save();
	ctx.shadowColor = color;
	ctx.shadowBlur = blur;
	draw();
	ctx.restore();
};

const polygon = (ctx, x, y, radius, sides, rotation = 0) => {
	ctx.beginPath();
	for (let i = 0; i < sides; i++) {
		const angle = rotation + (Math.PI * 2 * i) / sides;
		const px = x + Math.cos(angle) * radius;
		const py = y + Math.sin(angle) * radius;
		if (i === 0) ctx.moveTo(px, py);
		else ctx.lineTo(px, py);
	}
	ctx.closePath();
};

const drawBlaster = (ctx, x, y, size, angle, color) => {
	ctx.rotate(angle);
	ctx.fillStyle = color;
	ctx.fillRect(0, -3, size * 0.72, 6);
	ctx.fillStyle = "#f5f7fb";
	ctx.fillRect(size * 0.42, -1.5, size * 0.34, 3);
};

const drawCannon = (ctx, x, y, size, angle, color) => {
	ctx.rotate(angle);
	ctx.fillStyle = color;
	ctx.fillRect(-1, -5, size * 0.68, 10);
	ctx.fillStyle = "#11141b";
	ctx.fillRect(size * 0.46, -3, size * 0.18, 6);
};

const drawSniper = (ctx, x, y, size, angle, color) => {
	ctx.rotate(angle);
	ctx.strokeStyle = color;
	ctx.lineWidth = 4;
	ctx.beginPath();
	ctx.moveTo(-2, 0);
	ctx.lineTo(size * 0.82, 0);
	ctx.stroke();
	ctx.strokeStyle = "#f5f7fb";
	ctx.lineWidth = 1.5;
	ctx.beginPath();
	ctx.moveTo(size * 0.28, -5);
	ctx.lineTo(size * 0.5, 5);
	ctx.stroke();
};

const drawFrost = (ctx, x, y, size, angle, color) => {
	ctx.rotate(angle);
	ctx.strokeStyle = color;
	ctx.lineWidth = 2;
	for (let i = 0; i < 3; i++) {
		ctx.rotate((Math.PI * 2) / 3);
		ctx.beginPath();
		ctx.moveTo(0, 0);
		ctx.lineTo(size * 0.62, 0);
		ctx.moveTo(size * 0.42, -4);
		ctx.lineTo(size * 0.62, 0);
		ctx.lineTo(size * 0.42, 4);
		ctx.stroke();
	}
};

const drawTesla = (ctx, x, y, size, angle, color) => {
	ctx.rotate(angle);
	ctx.strokeStyle = color;
	ctx.lineWidth = 3;
	ctx.beginPath();
	ctx.moveTo(-4, -size * 0.22);
	ctx.lineTo(size * 0.18, -2);
	ctx.lineTo(1, 2);
	ctx.lineTo(size * 0.46, size * 0.24);
	ctx.stroke();
	ctx.fillStyle = color;
	ctx.beginPath();
	ctx.arc(size * 0.5, size * 0.24, 3, 0, Math.PI * 2);
	ctx.fill();
};

export const drawTowerSprite = (ctx, type, x, y, size = 30, angle = 0, selected = false) => {
	const def = TOWER_DEFS[type] || TOWER_DEFS.blaster;
	const color = def.color;

	glow(ctx, color, selected ? 24 : 13, () => {
		ctx.fillStyle = "#10141d";
		ctx.strokeStyle = color;
		ctx.lineWidth = selected ? 3 : 2;
		polygon(ctx, x, y, size * 0.52, type === "sniper" ? 4 : 6, Math.PI / 4);
		ctx.fill();
		ctx.stroke();
	});

	ctx.save();
	ctx.translate(x, y);
	if (type === "cannon") drawCannon(ctx, x, y, size, angle, color);
	else if (type === "sniper") drawSniper(ctx, x, y, size, angle, color);
	else if (type === "frost") drawFrost(ctx, x, y, size, angle, color);
	else if (type === "tesla") drawTesla(ctx, x, y, size, angle, color);
	else drawBlaster(ctx, x, y, size, angle, color);
	ctx.restore();

	ctx.fillStyle = "#f5f7fb";
	ctx.beginPath();
	ctx.arc(x, y, size * 0.16, 0, Math.PI * 2);
	ctx.fill();
};

const drawEnemyBody = (ctx, enemy, now) => {
	const pulse = Math.sin(now * 0.008 + enemy.id) * 0.08 + 1;
	const r = enemy.spriteSize * pulse;

	if (enemy.type === "tank" || enemy.type === "reinforced") {
		polygon(ctx, enemy.x, enemy.y, r * 1.15, 6, Math.PI / 6);
		return;
	}
	if (enemy.type === "sprinter") {
		polygon(ctx, enemy.x, enemy.y, r * 1.25, 3, Math.PI / 2);
		return;
	}
	if (enemy.type === "boss") {
		polygon(ctx, enemy.x, enemy.y, r * 1.25, 8, Math.PI / 8);
		return;
	}
	if (enemy.type === "healer" || enemy.type === "frostbite") {
		polygon(ctx, enemy.x, enemy.y, r * 1.1, 5, -Math.PI / 2);
		return;
	}

	ctx.beginPath();
	ctx.ellipse(enemy.x, enemy.y, r * 1.1, r * 0.86, 0, 0, Math.PI * 2);
};

export const drawEnemySprite = (ctx, enemy, now, options = {}) => {
	if (options.simplified) {
		ctx.fillStyle = enemy.color;
		ctx.beginPath();
		ctx.arc(enemy.x, enemy.y, enemy.size, 0, Math.PI * 2);
		ctx.fill();
		return;
	}

	const spriteSize = Math.max(enemy.size + 3, enemy.size * 1.35);
	const spriteEnemy = { ...enemy, spriteSize };

	ctx.fillStyle = "rgba(0,0,0,0.35)";
	ctx.beginPath();
	ctx.ellipse(enemy.x + 3, enemy.y + 4, spriteSize * 1.35, spriteSize * 0.66, 0, 0, Math.PI * 2);
	ctx.fill();

	glow(ctx, enemy.color, enemy.type === "boss" ? 22 : 13, () => {
		drawEnemyBody(ctx, spriteEnemy, now);
		ctx.fillStyle = enemy.color;
		ctx.fill();
		ctx.strokeStyle = "rgba(245,247,251,0.72)";
		ctx.lineWidth = enemy.type === "boss" ? 2.5 : 1.5;
		ctx.stroke();
	});

	ctx.fillStyle = "rgba(245,247,251,0.86)";
	ctx.beginPath();
	ctx.arc(enemy.x - spriteSize * 0.32, enemy.y - spriteSize * 0.18, Math.max(1.6, spriteSize * 0.16), 0, Math.PI * 2);
	ctx.arc(enemy.x + spriteSize * 0.32, enemy.y - spriteSize * 0.18, Math.max(1.6, spriteSize * 0.16), 0, Math.PI * 2);
	ctx.fill();

	if (enemy.heals) {
		ctx.strokeStyle = "rgba(157,242,127,0.82)";
		ctx.lineWidth = 2;
		ctx.beginPath();
		ctx.arc(enemy.x, enemy.y, spriteSize + 6, 0, Math.PI * 2);
		ctx.moveTo(enemy.x - 4, enemy.y);
		ctx.lineTo(enemy.x + 4, enemy.y);
		ctx.moveTo(enemy.x, enemy.y - 4);
		ctx.lineTo(enemy.x, enemy.y + 4);
		ctx.stroke();
	}
	if (enemy.reinforced) {
		ctx.strokeStyle = "rgba(220,230,240,0.86)";
		ctx.lineWidth = 3;
		ctx.beginPath();
		ctx.arc(enemy.x, enemy.y, spriteSize + 7, 0, Math.PI * 2);
		ctx.stroke();
	}
	if (enemy.fireman) {
		ctx.strokeStyle = "rgba(255,107,88,0.9)";
		ctx.lineWidth = 2;
		ctx.beginPath();
		ctx.moveTo(enemy.x, enemy.y - spriteSize - 7);
		ctx.lineTo(enemy.x + 6, enemy.y - spriteSize + 1);
		ctx.lineTo(enemy.x - 3, enemy.y - spriteSize + 1);
		ctx.lineTo(enemy.x + 2, enemy.y + spriteSize * 0.2);
		ctx.stroke();
	}
	if (enemy.frostImmune) {
		ctx.strokeStyle = "rgba(115,216,255,0.95)";
		ctx.lineWidth = 2;
		ctx.beginPath();
		ctx.moveTo(enemy.x - 6, enemy.y - spriteSize - 7);
		ctx.lineTo(enemy.x + 6, enemy.y - spriteSize + 5);
		ctx.moveTo(enemy.x + 6, enemy.y - spriteSize - 7);
		ctx.lineTo(enemy.x - 6, enemy.y - spriteSize + 5);
		ctx.stroke();
	}
};
